<!-- 小程序订单 -->
<template>
  <div class="diseaseList">
    <!-- 筛选区 + 新增 + 统计，与表格拼接成整块白卡 -->
    <div class="filter-bar">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="订单编号" size="small">
          <el-input
            v-model="listQuery.orderNumber"
            placeholder="请输入订单编号"
            clearable
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" size="small">
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入下单人手机号"
            clearable
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单状态" size="small">
          <el-select
            v-model="listQuery.status"
            placeholder="请选择"
            clearable
            @change="handleSearch"
          >
            <el-option
              v-for="(item, index) in statusList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleSearch"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
      <div class="filter-meta">
        共 <span class="meta-num">{{ listQuery.total || 0 }}</span> 条订单
      </div>
    </div>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        :height="tableHeight"
        header-bg-color="#F1F6FC"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="status" slot-scope="{ row }">
          <span :class="['status-text', `status-${row.status}`]">{{
            statusText(row.status)
          }}</span>
        </template>
        <template slot="phone" slot-scope="{ row }">
          <span :class="['cell-text', { 'cell-empty': !row.phone }]">{{
            row.phone || "—"
          }}</span>
        </template>
        <template slot="openid" slot-scope="{ row }">
          <el-tooltip
            :content="row.openid"
            placement="top"
            :disabled="!row.openid"
          >
            <span :class="['cell-text', { 'cell-empty': !row.openid }]">{{
              row.openid || "—"
            }}</span>
          </el-tooltip>
        </template>
        <template slot="money" slot-scope="{ row }">
          <span :class="['cell-text', { 'cell-empty': !row.money }]">{{
            row.money || "—"
          }}</span>
        </template>
        <template slot="message" slot-scope="{ row }">
          <el-tooltip
            :content="row.message"
            placement="top"
            :disabled="!row.message"
          >
            <span :class="['cell-text', { 'cell-empty': !row.message }]">{{
              row.message || "—"
            }}</span>
          </el-tooltip>
        </template>
        <template slot="createTime" slot-scope="{ row }">
          <span :class="['cell-text', { 'cell-empty': !row.createTime }]">{{
            row.createTime || "—"
          }}</span>
        </template>
        <template slot="paySuccessTime" slot-scope="{ row }">
          <span
            :class="['cell-text', { 'cell-empty': !row.paySuccessTime }]"
            >{{ row.paySuccessTime || "—" }}</span
          >
        </template>
        <template slot="outTradeNo" slot-scope="{ row }">
          <span :class="['cell-text', { 'cell-empty': !row.out_trade_no }]">{{
            row.out_trade_no || "—"
          }}</span>
        </template>
        <template slot="transactionId" slot-scope="{ row }">
          <el-tooltip
            :content="row.transaction_id"
            placement="top"
            :disabled="!row.transaction_id"
          >
            <span
              :class="['cell-text', { 'cell-empty': !row.transaction_id }]"
              >{{ row.transaction_id || "—" }}</span
            >
          </el-tooltip>
        </template>
        <template slot="logisticsNum" slot-scope="{ row }">
          <span
            :class="['cell-text', { 'cell-empty': !row.logistics_num }]"
            >{{ row.logistics_num || "—" }}</span
          >
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button
              size="mini"
              type="text"
              class="op-danger"
              :disabled="row.status !== 1"
              @click="handleRefund(row)"
              >退款</el-button
            >
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 退款表单 -->
    <el-dialog
      title="退款"
      :visible.sync="refundFormVisible"
      :close-on-click-modal="false"
      width="460px"
    >
      <el-form ref="form" :model="refundForm" label-width="80px">
        <el-form-item label="退款信息">
          <el-input
            type="textarea"
            clearable
            v-model="refundForm.info"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input
            clearable
            v-model.number="refundForm.refund"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="原因">
          <el-input
            type="textarea"
            clearable
            v-model="refundForm.reason"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="refundFormVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="saveRefund"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import { selectOrder } from "@/services/mini/order";
import { refund as refundApi } from "@/services/refund/index";
export default {
  components: {
    ElTable,
  },
  async created() {
    this.getListData();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  data() {
    return {
      loading: false,
      /* 视口高度，用于计算表格自适应高度 */
      winHeight: window.innerHeight,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        orderNumber: "",
        phone: "",
        status: "",
      },
      /* 表格数据 */
      tableData: [],
      /* 订单状态：0 待支付 1已支付 2申请退款 3已退款 */
      statusList: [
        { id: 0, name: "待支付" },
        { id: 1, name: "已支付" },
        { id: 2, name: "申请退款" },
        { id: 3, name: "已退款" },
      ],
      refundFormVisible: false,
      refundForm: {},
    };
  },
  computed: {
    listHeader,
    /* 表格高度：尽量占满视口，白卡整体向下拉长 */
    tableHeight() {
      return `${Math.max(this.winHeight - 300, 320)}px`;
    },
  },
  watch: {},
  methods: {
    handleResize() {
      this.winHeight = window.innerHeight;
    },
    async getListData(listQuery) {
      this.loading = true;
      try {
        const { data, code, count } = await selectOrder(
          listQuery || this.listQuery
        );
        if (code === 200) {
          this.tableData = data || [];
          this.listQuery.total = count || 0;
        }
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 300);
      }
    },
    /* 搜索：手机号/订单编号回车或清空触发 */
    async handleSearch() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },

    /* 订单状态文案 */
    statusText(status) {
      const item = this.statusList.find((i) => i.id === status);
      return item ? item.name : "——";
    },

    /* 退款 */
    handleRefund(row) {
      this.refundFormVisible = true;
      this.refundForm = {
        ...JSON.parse(JSON.stringify(row)),
        info: `订单编号：${row.orderNumber}，产品：${row.productType}`,
        refund: "",
      };
    },

    saveRefund() {
      const { transaction_id, money, refund, reason } = this.refundForm;
      const queryList = {
        transaction_id,
        total: money,
        refund,
        reason,
      };
      this.$confirm("确定对该订单进行退款, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          refundApi(queryList).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "发起退款成功!",
              });
              this.refundFormVisible = false;
            }
          });
        })
        .catch(() => {});
    },

    /* 分页 */
    handleCurrentChange(e) {
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e;
      this.getListData();
    },
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

/* 筛选区：白色圆角卡片上半部，与表格拼接成一整块白卡 */
.filter-bar {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 16px 16px 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  .filter-form {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .el-form-item {
    margin-right: 16px;
    margin-bottom: 8px;

    .el-input__inner {
      width: 200px;
    }
  }
  /* 新增按钮无 label，单独上移一点与输入框视觉对齐 */
  .item-add {
    margin-top: -6px;
  }

  /* 右侧统计，平衡一行视觉重心 */
  .filter-meta {
    flex-shrink: 0;
    padding-top: 6px;
    font-size: 13px;
    color: #8a94a6;

    .meta-num {
      color: #3d8dfc;
      font-weight: 600;
    }
  }
}

/* 表格区：白卡下半部，与筛选区严丝合缝 */
.tableList {
  border-radius: 0 0 8px 8px;
  background: #fff;
  padding: 12px 16px 16px;

  /* 单元格不换行，超出显示省略号 */
  /deep/ .el-table .cell {
    white-space: nowrap;
  }

  /* 单元格文本：单行省略 */
  .cell-text {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
  /* 无数据占位，避免单元格整片空白 */
  .cell-empty {
    color: #c0c4cc;
  }

  /* 订单状态文案：0待支付 1已支付 2申请退款 3已退款 */
  .status-text {
    &.status-0 {
      color: #fb9a0e;
    }
    &.status-1 {
      color: #30a46c;
    }
    &.status-2 {
      color: #ef7a59;
    }
    &.status-3 {
      color: #8a94a6;
    }
  }
}

/* 操作列：编辑蓝字 / 删除·退款红字 */
.operation {
  display: flex;
  align-items: center;
  gap: 4px;

  .el-button {
    margin: 0;
    padding: 0 6px;
    font-size: 13px;
    background: transparent;
  }
  .op-edit {
    color: #3d8dfc;
  }
  .op-danger {
    color: #f56c6c;
  }
}
</style>
